"use client";

import { Text } from "@pamperedchef/design-system";
import { useLocale } from "next-intl";
import { PriceDisplay } from "@/composites/product/PriceDisplay";
import * as styles from "./KitPrice.module.scss";

export interface KitPriceProps {
	priceText: string;
	originalPriceText?: string;
	percentDiscountText?: string;
}
function parsePriceText(text: string | undefined): number | undefined {
	if (!text) return undefined;
	const cleaned = text.replace(/[^0-9.\-]/g, "");
	if (!cleaned) return undefined;
	const value = Number.parseFloat(cleaned);
	return Number.isFinite(value) ? value : undefined;
}

export function KitPrice({
	priceText,
	originalPriceText,
	percentDiscountText
}: KitPriceProps) {
	const locale = useLocale();
	const currency = locale.toLowerCase().endsWith("ca") ? "CAD" : "USD";
	const display = parsePriceText(priceText);
	const strikeThrough = parsePriceText(originalPriceText);

	return (
		<div className={styles["kit-price"]} data-component="KitPrice">
			{display !== undefined ? (
				<PriceDisplay
					display={display}
					strikeThrough={strikeThrough}
					currency={currency}
					locale={locale}
					size="small"
				/>
			) : null}
			{percentDiscountText ? (
				<Text
					tag="span"
					styledAs="mdr"
					className={styles["kit-price__discount"]}
				>
					{percentDiscountText}
				</Text>
			) : null}
		</div>
	);
}
